export default __webpack_public_path__ + "static/media/einstein_logo.09a723de.png";